var Water = require('water/main');

(function(){




  window.addEventListener('DOMContentLoaded', function(){

    if (navigator.userAgent.indexOf('Android') > 0){
    } else {
      Water.init( 'canvas-3d' );
    }
    
  }, false);
})();









//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/water.js
// module id = 0
// module chunks = 1